import React, { useEffect, useState } from 'react'
import { Modal, ListGroup, Button, Col, Image } from 'react-bootstrap';
import { useStateValue } from '../../utilities/StateProvider';
import { MdClose } from 'react-icons/md';
import './Cart.scss';
import { CARRITO } from '../../../images/images';

export default function Cart(props) {

    const [ { cart, isInterior }, dispatch] = useStateValue();
    const [ cartTotal, setCartTotal] = useState(0);
    const [ cartValue, setCartValue] = useState(0);

    useEffect(() => {
        const checkCartTotal = () => {
            const newCount = Object.values(cart)
            .map((entry) => (Number(entry.quantity)))
            .reduce((acc, curr) => (acc + curr), 0);
            const newValue = Object.values(cart)
            .map((entry) => (
                (!isInterior) ?
                Number(entry.price) * Number(entry.quantity) :
                Number(entry.priceInterior) * Number(entry.quantity)
            ))
            .reduce((acc, curr) => (acc + curr), 0);
            setCartTotal(newCount);
            setCartValue(newValue);
        };
        checkCartTotal();
    })

    const renderProducts = (props) => {
        const productList = Object.entries(cart)
        .map(([key, value]) => (
            <ListGroup.Item className="list-item">
                    <Col xs={6}>
                        <span className="list-name">{value.name}</span>
                    </Col>
                    <Col xs={2}>
                        <span className="list-ammount">{value.quantity}</span>
                    </Col>
                    <Col xs={2}>
                        <span className="list-ammount">${value.price * value.quantity}</span>
                    </Col>
                    <Col xs={2}>
                        <Button variant="outline-dark" className="cart-delete-button">
                            <MdClose onClick={removeFromCart(key)}/>
                        </Button>
                    </Col>
            </ListGroup.Item>
        ));

        return (
            <ListGroup {...props} className="cart-tooltip" variant="flush">
                {productList}
            </ListGroup>
        );
    }
    

    const removeFromCart = (key) => () => {

        const newCart = cart;
        delete newCart[key];
        
        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart,
        });
    }

    return (
        <Modal show={props.show} onHide={props.onHide} centered className="cart-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="cart-modal-total">
                        <Image src={CARRITO} width={80}/>
                        <div>
                            <div className="cart-modal-quantity">{`${cartTotal} ${(cartTotal === 1) ? 'item' : 'items'}`}</div>
                            <div className="cart-modal-value">Total: ${cartValue}</div>
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderProducts()}
            </Modal.Body>
        </Modal>
    )
}
